import React, { useEffect } from "react";
import { useStore } from "../../context/StoreContext";

export default function Toast() {
  const { toast, setToast } = useStore();

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ ...toast, show: false });
      }, 15000);
      return () => clearTimeout(timer);
    }
  }, [toast.show, setToast, toast]);

  return (
    <div className="toast-container position-fixed end-0 p-3" style={{ top: '70px' }}>
      <div className={`toast ${toast.show ? 'show' : 'hide'} align-items-center text-white ${toast.type === 'success' ? 'bg-success' : 'bg-danger'} border-0`} role="alert">
        <div className="d-flex">
          <div className="toast-body">
            {toast.message}
          </div>
          <button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setToast({ ...toast, show: false })}></button>
        </div>
      </div>
    </div>
  );
}